import type { StoneFlickingConfig } from "../types/game-config";
import {
  generateDeploymentSeeds,
  getStonesPerPlayer,
} from "../utils/sector-placement";

const DEFAULT_BOARD = {
  centerX: 5,
  centerY: 5,
  radius: 5,
  boundaryPadding: 0.3,
} as const;

const DEFAULT_DYNAMICS = {
  timeStep: 1 / 60,
  frictionCoefficient: 3.0,
  velocityThreshold: 0.01,
  minImpulseMagnitude: 0.1,
  restitutionCoefficient: 0.8,
  maxSimulationSteps: 600,
} as const;

const DEFAULT_ACCURACY = {
  power: { min: 0.8, max: 0.95 },
  direction: { min: 0.8, max: 0.95 },
  directionMaxErrorDeg: 15,
} as const;

const DEFAULT_PIECES = [
  { archetype: "STONE", radius: 0.35, mass: 1.0 },
] as const;

export function createConfigForPlayerCount(
  playerCount: 2 | 3 | 4,
): StoneFlickingConfig {
  const stonesPerPlayer = getStonesPerPlayer(playerCount);
  const seeds = generateDeploymentSeeds(
    playerCount,
    stonesPerPlayer,
    DEFAULT_BOARD,
  );

  return {
    board: DEFAULT_BOARD,
    dynamics: DEFAULT_DYNAMICS,
    accuracy: DEFAULT_ACCURACY,
    pieces: DEFAULT_PIECES,
    deployment: { seeds },
    maxTurns: 50,
    playerCount,
  };
}

export const DEFAULT_STONE_FLICKING_CONFIG: StoneFlickingConfig =
  createConfigForPlayerCount(2);
